import { render, staticRenderFns } from "./EmailConfigurationEdit.vue?vue&type=template&id=0b0f7431&"
import script from "./EmailConfigurationEdit.vue?vue&type=script&lang=js&"
export * from "./EmailConfigurationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports